import React, { useState } from 'react';

import { ActiveUploads } from '@trqk/components';

import { ActiveIngestionsEmptyState, ManageGapAnalysisHeader } from '.';
import { contentWidth, rowHeight, progressBarSpacer } from '../../constants';

interface ActiveIngestionsProps {
    height: number;
    inProgressTasks: UploadStatementTask[];
    manageGapAnalysisHeaderData: ManageGapAnalysisHeaderData | null;
    /**
     * The `remove` function provided to the Manage Statements modal
     */
    remove(removeModalInput: RemoveModalInput): void;
}

export const ActiveIngestions = ({
    height,
    inProgressTasks,
    manageGapAnalysisHeaderData,
    remove,
}: ActiveIngestionsProps): JSX.Element => {
    const [didCloseHeader, setDidCloseHeader] = useState(false);

    const header =
        manageGapAnalysisHeaderData !== null && !didCloseHeader ? (
            <ManageGapAnalysisHeader
                data={manageGapAnalysisHeaderData}
                remove={remove}
                setDidCloseHeader={setDidCloseHeader}
            />
        ) : null;

    return (
        <ActiveUploads
            header={header}
            height={height}
            inProgressTasks={inProgressTasks}
            emptyState={
                manageGapAnalysisHeaderData ? null : (
                    <ActiveIngestionsEmptyState />
                )
            }
            rowSize={{
                height: rowHeight - 2 * progressBarSpacer,
                marginY: progressBarSpacer,
                width: contentWidth,
            }}
        />
    );
};
